import { render, staticRenderFns } from "./materials-handling.vue?vue&type=template&id=3f3003eb&scoped=true"
import script from "./materials-handling.vue?vue&type=script&lang=js"
export * from "./materials-handling.vue?vue&type=script&lang=js"
import style0 from "./materials-handling.vue?vue&type=style&index=0&id=3f3003eb&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f3003eb",
  null
  
)

export default component.exports